var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Spanish flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#aa151b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 8,
    fill: "#f1bf00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M5.2 6.1h1.5v3.8H5.2zM6.7 6.8h1.2v2.6H6.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.8,
    r: 0.35,
    fill: "#f1bf00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSpain);
export default __webpack_public_path__ + "static/media/flag-spain.47a48e504f62b9419b3831e0ec4e0c5f.svg";
export { ForwardRef as ReactComponent };